import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { MedicalDataAccessAuthorization, PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

import { dateFormatter } from '@dreryk/react-common';
import { SidePanelListItem } from '@dreryk/react-components';

import { ConsentsAndAuthorizationsDocumentAttachmentsModalOpener } from '~legacy.patient';

import { PatientAuthorizationsListItemContent } from './PatientAuthorizationsListItemContent';
import {
   consentsAndAuthorizationsSortByDate,
   patientConsentsAndAuthorizationVisitor,
} from './PatientConsentsAndAuthorizationsSidePanelList.utils';
import { PatientConsentsListItemContent } from './PatientConsentsListItemContent';

type UseCreatePatientConsentsAndAuthorizationsListItemsOptions = {
   patientConsents: PatientConsentDocument[];
   patientAuthorizations: MedicalDataAccessAuthorization[];
};

export const useCreatePatientConsentsAndAuthorizationsListItems = (
   options: UseCreatePatientConsentsAndAuthorizationsListItemsOptions
): SidePanelListItem[] | undefined => {
   return useMemo(() => {
      const consentsAndAuthorizations = [...options.patientConsents, ...options.patientAuthorizations];

      if (isEmpty(consentsAndAuthorizations)) {
         return undefined;
      }

      const consentsAndAuthorizationsSortedByDate = consentsAndAuthorizationsSortByDate(consentsAndAuthorizations);

      return consentsAndAuthorizationsSortedByDate.map((consentAndAuthorization, index) => {
         return patientConsentsAndAuthorizationVisitor(consentAndAuthorization)({
            forAuthorization: (patientAuthorization) => ({
               id: patientAuthorization.id,
               testId: index,
               headerContent: <>{dateFormatter(patientAuthorization.enterDate)}</>,
               content: <PatientAuthorizationsListItemContent patientAuthorization={patientAuthorization} />,
            }),
            forConsent: (patientConsent) => ({
               id: patientConsent.id,
               testId: index,
               headerContent: <>{dateFormatter(patientConsent.creationDate)}</>,
               content: (
                  <ConsentsAndAuthorizationsDocumentAttachmentsModalOpener
                     attachments={patientConsent.attachments}
                     name={patientConsent.name}
                  >
                     {({ openModal }) => (
                        <PatientConsentsListItemContent
                           patientConsent={patientConsent}
                           onShowMoreAttachmentsClick={openModal}
                        />
                     )}
                  </ConsentsAndAuthorizationsDocumentAttachmentsModalOpener>
               ),
            }),
         });
      });
   }, [options.patientAuthorizations, options.patientConsents]);
};
